import React, { useState } from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import Button from "../components/atoms/Button";
import Input from "../components/atoms/Input";

/**
 * 로그인 1단계 — 이메일/비번 검증 후 인증코드 메일 발송 → /check 로 이동.
 * 토큰은 /check 의 verify 단계에서 발급된다 (다른 어드민과 동일).
 */
function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError("");
    setSubmitting(true);
    try {
      // 1) 자격 검증
      const login = await api.post("/admin/login", {
        email: email.trim().toLowerCase(),
        password: password.trim(),
      });
      if (!login?.data?.success) {
        setError(login?.data?.alert || "로그인에 실패했습니다.");
        return;
      }

      // 2) 인증코드 메일 발송
      const certify = await api.post("/admin/certify", {
        email: email.trim().toLowerCase(),
      });
      if (!certify?.data?.success) {
        setError(certify?.data?.alert || "인증코드 발송에 실패했습니다.");
        return;
      }

      // 3) /check 로 이동 — 이메일은 다음 단계에서 사용
      localStorage.setItem("email", email.trim().toLowerCase());
      navigate("/check", { replace: true });
    } catch (err) {
      setError("서버에 연결할 수 없습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Wrapper>
      <Card onSubmit={submit}>
        <Brand>더트루 변경 요청</Brand>
        <Sub>관리자 로그인</Sub>
        <Field>
          <Label>이메일</Label>
          <Input
            type="email"
            placeholder="이메일"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </Field>
        <Field>
          <Label>비밀번호</Label>
          <Input
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </Field>
        {error && <ErrorText>{error}</ErrorText>}
        <Button type="submit" block disabled={submitting}>
          {submitting ? "확인 중..." : "다음"}
        </Button>
      </Card>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f6f7f9;
`;
const Card = styled.form`
  width: 100%;
  max-width: 420px;
  padding: 28px 24px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const Brand = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #003580;
  text-align: center;
`;
const Sub = styled.div`
  font-size: 13px;
  color: #888;
  text-align: center;
  margin-bottom: 8px;
`;
const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const Label = styled.label`
  font-size: 13px;
  color: #555;
`;
const ErrorText = styled.div`
  color: #fb4d44;
  font-size: 13px;
`;

export default LoginPage;
